// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3-eJB","header":"ReportDetails_header__3_oFb","title":"ReportDetails_title__3EUdT","left":"ReportDetails_left__3FaHX"};